import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'SalesOrder',
        caption: 'Sales order',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true,
    },
    {
        dataField: 'CustomerId',
        caption: 'Customer',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'CustomerPO',
        caption: 'Customer P/O',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: false
    },
    {
        dataField: 'SalesEntity',
        caption: 'Sales entity',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'OrderDate',
        caption: 'Order Date',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'EarliestShip',
        caption: 'Earliest ship',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
    {
        dataField: 'CustomerName',
        caption: 'Customer name',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    }
];

export const salesOrderLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details',
    tabbedLookup: {
        isTabbedLookup: true,
    }
};
